import './ProductSearchModal.scss';

import { API } from 'aws-amplify';
import getSymbolFromCurrency from 'currency-symbol-map';
import MaterialTable from 'material-table';
import React, { Component } from 'react';
import CurrencyFormat from 'react-currency-format';
import Modal from 'react-responsive-modal';

import { handleUnauthorizedError } from '../../../utils';

class ProductSearchModal extends Component {
    render() {
        const { setItemSelected, setModalOpen, modalOpen, item, facia } = this.props;

        return (
            <div>
                <Modal
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    classNames={{
                        modal: 'exchange-product-search-modal',
                        closeButton: 'exchange-product-search-modal-close',
                    }}
                    center
                >
                    <MaterialTable
                        title="Product Search"
                        columns={[
                            {
                                title: 'Image',
                                render: (product) => (
                                    <img
                                        className="modal-table-image"
                                        src={product.media[0].location}
                                        alt={product.name}
                                    />
                                ),
                            },
                            {
                                title: 'Name',
                                field: 'name',
                            },
                            {
                                title: 'RRP',
                                render: (product) => (
                                    <CurrencyFormat
                                        prefix={getSymbolFromCurrency(product.prices.currency)}
                                        thousandSeparator={true}
                                        displayType="text"
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        value={product.prices.rrp}
                                    />
                                ),
                            },
                            {
                                title: 'Price',
                                render: (product) => (
                                    <CurrencyFormat
                                        prefix={getSymbolFromCurrency(product.prices.currency)}
                                        thousandSeparator={true}
                                        displayType="text"
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        value={product.prices.price}
                                    />
                                ),
                            },
                        ]}
                        data={(query) =>
                            new Promise(async (resolve, reject) => {
                                if (!query.search.length) {
                                    resolve({
                                        data: [],
                                        page: 0,
                                        totalCount: 0,
                                    });
                                    return;
                                }
                                let url = `/admin?facia=${facia}&size=${query.pageSize}&start=${
                                    query.page + 1
                                }&search=${query.search}`;

                                return API.get('product', url, {}).then(
                                    (result) => {
                                        resolve({
                                            data: result.products,
                                            page: parseInt(result.start) - 1,
                                            totalCount: result.total,
                                        });
                                    },
                                    (error) => {
                                        handleUnauthorizedError(error);
                                        console.log(error);
                                    },
                                );
                            })
                        }
                        actions={[
                            (rowData) => ({
                                icon: 'swap_horizontal_circle',
                                tooltip:
                                    rowData.prices.price > item.prices.discountPrice / 100
                                        ? 'Price greater than exchange item'
                                        : 'Exchange Item',
                                disabled: rowData.prices.price > item.prices.discountPrice / 100,
                                onClick: (event, product) => {
                                    setItemSelected(product);
                                    setModalOpen(false);
                                },
                            }),
                        ]}
                        options={{
                            actionsColumnIndex: -1,
                            debounceInterval: 800,
                            pageSize: 10,
                        }}
                    />
                </Modal>
            </div>
        );
    }
}

export default ProductSearchModal;
